import { isInstalledPwa } from './isInstalledPwa'

const RELOAD_AFTER_CLEANUP_KEY = 'otw-pwa-unregister-reload'

/**
 * Legacy portal builds registered a service worker in normal browser tabs.
 * Installed PWAs keep the worker; tabs unregister, clear Workbox caches, and reload once.
 */
export async function unregisterServiceWorkerInBrowserTab(): Promise<void> {
  if (!import.meta.env.PROD || isInstalledPwa()) {
    return
  }
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return
  }

  if (sessionStorage.getItem(RELOAD_AFTER_CLEANUP_KEY) === '1') {
    sessionStorage.removeItem(RELOAD_AFTER_CLEANUP_KEY)
    return
  }

  const registrations = await navigator.serviceWorker.getRegistrations()
  if (registrations.length === 0) {
    return
  }

  await Promise.all(registrations.map(registration => registration.unregister()))

  if ('caches' in window) {
    const keys = await caches.keys()
    await Promise.all(keys.map(key => caches.delete(key)))
  }

  sessionStorage.setItem(RELOAD_AFTER_CLEANUP_KEY, '1')
  window.location.reload()
}
